export default "__VITE_ASSET__CxEh5I87__"